import { API_URL } from '../config/api';
import { authenticatedFetch } from '../utils/authenticatedFetch';

export interface CameraPhoto {
  timestamp: string;
  cam_id: string;
  file_path: string;
  file_name: string;
}

export interface CameraPhotoPage {
  total: number;
  page: number;
  limit: number;
  photos: CameraPhoto[];
}

export const cameraService = {
  getSources: async (): Promise<string[]> => {
    const response = await authenticatedFetch(`${API_URL}/camera/cameras`);
    if (!response.ok) throw new Error('Failed to fetch camera sources');
    const data = await response.json();
    return data.cameras;
  },
  getLatestPhotos: async (): Promise<CameraPhoto[]> => {
    const response = await authenticatedFetch(`${API_URL}/camera/latest`);
    if (!response.ok) throw new Error('Failed to fetch latest camera photos');
    return await response.json();
  },
  getPhotos: async (cam_id: string, page = 1, limit = 20): Promise<CameraPhotoPage> => {
    const response = await authenticatedFetch(`${API_URL}/camera/photos?cam_id=${encodeURIComponent(cam_id)}&page=${page}&limit=${limit}`);
    if (!response.ok) throw new Error('Failed to fetch camera photos');
    return await response.json();
  }
}; 